import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitKeyDecisionsConfigTask extends Task {
    constructor(assetLibrary, keyDecisionsConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const keyDecisionsJson = assetLibrary.getAsset("key-decisions-config");
            keyDecisionsConfig.setPropertiesFromObject(keyDecisionsJson);

            callback(this);
        }
    }
}